import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const icon = <CheckBoxOutlineBlank fontSize='small' />;
const checkedIcon = <CheckBox fontSize='small' />;

export default function CheckboxDropdown({ options, onChange }) {
  const { t } = useTranslation();
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [searchTerm, setSearchTerm] = React.useState('');
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    onChange(selectedOptions);
  }, [selectedOptions]);

  const handleChange = (event, value) => {
    if (value.some((item) => item.value === 'selectAll')) {
      const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().startsWith(searchTerm.toLowerCase()),
      );

      if (selectedOptions.length === filteredOptions.length) {
        setSelectedOptions([]);
      } else {
        setSelectedOptions(filteredOptions);
      }
      setOpen(false);
    } else {
      setSelectedOptions(value);
    }
  };

  return (
    <Autocomplete
      size='small'
      multiple
      options={[
        { value: 'selectAll', label: t('payments.dataMappings.selectAll') },
        ...options,
      ]}
      disableCloseOnSelect
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      value={selectedOptions}
      onChange={handleChange}
      onInputChange={(event, newInputValue) => {
        setSearchTerm(newInputValue);
      }}
      getOptionLabel={(option) => option.label}
      filterOptions={(options, state) => {
        const filtered = options.filter(
          (option) =>
            option.value === 'selectAll' ||
            option.label.toLowerCase().includes(state.inputValue.toLowerCase()),
        );

        return filtered;
      }}
      renderTags={(selected) =>
        selected.length > 0
          ? t('payments.dataMappings.selectedCount', { count: selected.length })
          : null
      }
      renderOption={(props, option, { selected }) => {
        props.key = option.value + '';

        return (
          <li key={option.value + ''} {...props} style={{ padding: '0px 0px' }}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={
                selected ||
                (option.value === 'selectAll' &&
                  selectedOptions.length === options.length)
              }
            />
            {option.label}
          </li>
        );
      }}
      style={{ width: 300 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('payments.dataMappings.label')}
          placeholder={t('payments.dataMappings.searchPlaceholder')}
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
    />
  );
}
